import { formatDuration } from "utils";

export const getDistance = (finishIn: number) => {
  const timestamp = Math.round((finishIn - Date.now()) / 1000);
  return formatDuration(timestamp);
};
